module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-p-800-8411aefed842ae51674f1932fadd336e.jpg";